import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";

export const blanketTheme = themed({
    background: {
        "lodestar-light": "#000000", //no token for lodestar color that's been used here (black)
        "ursa-light": color("color--background--neutral-inverse--stronger"),
    },
    opacity: {
        "lodestar-light": 0.1,
        "ursa-light": 0.08,
    },
});
